/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
function n(n,t){const r=n.slice(0,t),e=t-r.length;for(let o=0;o<e;o++){const n=r[r.length-1];r.push(n)}return r}function t(n){if(!n)return[0,0,0,0];const{r:t,g:r,b:e,a:o}=n;return[t*(o/255),r*(o/255),e*(o/255),o]}export{n as padStops,t as premultiplyColor};
